import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Ahorro from '@/components/Ahorro'
import Gastos from '@/components/Gastos'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/ahorro',
      name: 'Ahorro',
      component: Ahorro
    },
    {
      path: '/',
      name: 'Gastos',
      component: Gastos
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js